// İSG Portal (web-expert + web-supplier) — liste satırı ⋮ eylem menüsü (S33 Slice 4 QA fix, defekt
// #4 — `S33-4-list-pages-qa.md`; GL #25'ten beri ortak paket). README Stage 2/§4 "row actions live
// in a `⋮` overflow menu": satırın BİRİNCİL "aç" eylemi ad/başlık hücresinin kendisi (bağlantı ya
// da düzenleme açan düğme) olur, İKİNCİL/YIKICI eylemler (düzenle, sil…) bu tek `⋮` menüsüne
// toplanır. Bu bileşen o tekrar eden Radix `DropdownMenu` iskeletini liste sayfaları için TEK
// yerden kurar; iki portalın personel ve araç tabloları bunu kullanır.
//
// Kalıcı (yıkıcı olmayan) ve yıkıcı öğeler ayrı gruplardır; ikisi de doluysa aralarına TEK
// bir ayraç konur (ör. EP izin Personel: "Giriş İzni Ver/Geri Al" | ayraç | "Kapsamdan çıkar").
// Yıkıcı öğeler burada KENDİ onayını YAPMAZ — çağıran sayfa var olan `ConfirmDialog`'unu
// `onSelect` içinde açmaya devam eder (coordinator: "destructive items still go through the
// existing confirm dialogs").

import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { MoreVertical } from 'lucide-react';
import type { ReactNode, Ref } from 'react';

export interface RowAction {
  key: string;
  label: ReactNode;
  onSelect: () => void;
  /** İzin kapısı — README "Keep every permission gate on each menu item". */
  disabled?: boolean;
  /** `true` ise kırmızı metin + ayraçtan SONRA render edilir (silme, iptal, devre dışı bırakma…). */
  destructive?: boolean;
}

export interface RowActionsMenuProps {
  items: RowAction[];
  /** Tetikleyicinin erişilebilir adı (i18n ile, satırı tanımlayan bir adla — ör. kişi/kayıt adı). */
  ariaLabel: string;
  /** ⋮ düğmesinin ref'i — çağıran, satırın ad bağlantısı yoksa onay diyaloğunun odak dönüşünü
   * bu düğmeye bağlayabilsin (emsal `TableToolbar.newButtonRef`). */
  triggerRef?: Ref<HTMLButtonElement>;
}

export function RowActionsMenu({ items, ariaLabel, triggerRef }: RowActionsMenuProps) {
  const primary = items.filter((item) => !item.destructive);
  const destructive = items.filter((item) => item.destructive);

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger
        ref={triggerRef}
        className="flex h-8 w-8 items-center justify-center rounded-md text-muted hover:bg-surface-muted hover:text-fg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        aria-label={ariaLabel}
      >
        <MoreVertical className="h-4 w-4" aria-hidden="true" />
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          align="end"
          sideOffset={6}
          className="z-[var(--z-dropdown)] min-w-[12rem] overflow-hidden rounded-md border border-border bg-surface p-1 shadow-md"
        >
          {primary.map((item) => (
            <DropdownMenu.Item
              key={item.key}
              disabled={item.disabled}
              onSelect={item.onSelect}
              className="flex cursor-pointer select-none items-center rounded px-2 py-1.5 text-sm text-fg outline-none data-[highlighted]:bg-surface-muted data-[disabled]:cursor-not-allowed data-[disabled]:text-muted"
            >
              {item.label}
            </DropdownMenu.Item>
          ))}
          {primary.length > 0 && destructive.length > 0 ? (
            <DropdownMenu.Separator className="my-1 h-px bg-border" />
          ) : null}
          {destructive.map((item) => (
            <DropdownMenu.Item
              key={item.key}
              disabled={item.disabled}
              onSelect={item.onSelect}
              className="flex cursor-pointer select-none items-center rounded px-2 py-1.5 text-sm text-danger outline-none data-[highlighted]:bg-danger-subtle data-[disabled]:cursor-not-allowed data-[disabled]:text-muted"
            >
              {item.label}
            </DropdownMenu.Item>
          ))}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
